import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import VueAliplayerV2 from 'vue-aliplayer-v2'
import moment from 'moment'
// 中文简体
moment.locale('zh-cn')

import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false

Vue.use(VueAliplayerV2)
Vue.use(ElementUI)

Vue.prototype.$moment = moment

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
